import IPlanFirm from './IPlanFirm';
import PlanFirmsApi from './PlanFirmsApi';
import * as ActionTypes from './ActionTypes';

function listSucceeded(result: IPlanFirm[]) {
    return { type: ActionTypes.LIST_PLAN_FIRMS_SUCCESS, result: result };
}

function listFailed(error: any) {
    return { type: ActionTypes.LIST_PLAN_FIRMS_FAILURE, error: error };
}

export function list(): (dispatch: (result: any) => void, getState: any) => any {
    return function (dispatch: (result: any) => void, getState: any) {
        return PlanFirmsApi.list()
            .then((result: IPlanFirm[]) => {
                dispatch(listSucceeded(result));
            })
            .catch((error: any) => {
                dispatch(listFailed(error));
                throw error;
            });
    };
}

function createSucceeded(result: IPlanFirm) {
    return { type: ActionTypes.CREATE_PLAN_FIRM_SUCCESS, result: result };
}

function createFailed(error: any) {
    return { type: ActionTypes.CREATE_PLAN_FIRM_FAILURE, error: error };
}

export function create(name: string) {
    return function (dispatch: any, getState: any) {
        return PlanFirmsApi.create(name)
            .then((result: IPlanFirm) => {
                dispatch(createSucceeded(result));
            })
            .catch((error: any) => {
                dispatch(createFailed(error));
                throw error;
            });
    };
}

function editSucceeded(result: IPlanFirm) {
    return { type: ActionTypes.EDIT_PLAN_FIRM_SUCCESS, result: result };
}

function editFailed(error: string) {
    return { type: ActionTypes.EDIT_PLAN_FIRM_FAILURE, error: error };
}

export function edit(id: number) {
    return function (dispatch: (result: any) => void) {
        return PlanFirmsApi.edit(id)
            .then((result: IPlanFirm) => {
                dispatch(editSucceeded(result));
            })
            .catch((error: string) => {
                dispatch(editFailed(error));
                throw error;
            });
    };
}

function updateSucceeded(result: IPlanFirm) {
    return { type: ActionTypes.UPDATE_PLAN_FIRM_SUCCESS, result: result };
}

function updateFailed(error: string) {
    return { type: ActionTypes.UPDATE_PLAN_FIRM_FAILURE, error: error };
}

export function update(planFirm: IPlanFirm) {
    return function (dispatch: (result: any) => void) {
        return PlanFirmsApi.update(planFirm)
            .then((result: IPlanFirm) => {
                dispatch(updateSucceeded(result));
            })
            .catch((error: string) => {
                dispatch(updateFailed(error));
                throw error;
            });
    };
}

function deleteSuccess(result: number) {
    return { type: ActionTypes.DELETE_PLAN_FIRM_SUCCESS, result: result };
}

function deleteFailed(error: string) {
    return { type: ActionTypes.DELETE_PLAN_FIRM_FAILURE, error: error };
}

export function deletePlanFirm(
    id: number
): (dispatch: (result: any) => void, getState: any) => any {
    return function (dispatch: (result: any) => void, getState: any) {
        return PlanFirmsApi.delete(id)
            .then((result: any) => {
                dispatch(deleteSuccess(id));
            })
            .catch((error: string) => {
                dispatch(deleteFailed(error));
                throw error;
            });
    };
}
